module.exports = __webpack_public_path__ + "static/media/1_3.8e9ebd6b.png";